import { useMemo, useRef, useState } from "react";
import {
  MapContainer,
  Marker,
  Popup,
  TileLayer,
  ZoomControl,
  FeatureGroup,
  GeoJSON,
} from "react-leaflet";

import clientComponent from "../config/clientComponents";
import ChangeView from "../utils/ChangeView";
import "leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.css";
import "leaflet-defaulticon-compatibility";
import "leaflet-fullscreen/dist/Leaflet.fullscreen.js";
import "leaflet-fullscreen/dist/leaflet.fullscreen.css";
import "leaflet/dist/leaflet.css";
import "leaflet-gesture-handling/dist/leaflet-gesture-handling.css";
import MarkerClusterGroup from "react-leaflet-cluster";
import TileLayerCustom from "../config/configCartoTileLayer";

const Map = ({
  data,
  selectedInstitution,
  setSelectedInstitution,
  client,
  filtersKeys,
  filters,
  scrollbarRef,
  lineRefs,
  customMarkerRefs,
  popupRefs,
  mapRef,
  setMapRef,
  sizeState,
  userCurrentPosition,
  selectedGeoAdress,
  setFilteredEntities,
  legende
}) => {
  const clusterRef = useRef(null);

  //--- Dynamic import
  const MarkerIcon = clientComponent["MarkerIcon"];
  const MapLegend = clientComponent["MapLegend"];
  const CustomMarker = clientComponent["CustomMarker"];

  let GeoData = {};
  if (process.env.REACT_APP_GEODATA === "true") {
    GeoData = clientComponent["GeoData"];
  }

  //--- Get overlayScrollbar Instance from the parent component
  let scrollbarInstance = {};
  if (scrollbarRef.current) {
    scrollbarInstance = scrollbarRef.current.osInstance();
  }

  //--- Creation of the marker component list
  const markers = data.map((entity, i) => {
    let isSelected = false;
    let colorsArray = [];
    let innerIcon = "";
    if (entity.latitude && entity.longitude) {
      const indexFiltersArrayColor = process.env.REACT_APP_INDEX_FILTER_ARRAY_COLOR ? process.env.REACT_APP_INDEX_FILTER_ARRAY_COLOR : 0
      //--- Create Array of colors looping on first filter key
      if (process.env.REACT_APP_LEGENDE_ENABLE === "true") {
        if (legende?.length > 0) {
          for (const element of entity[filtersKeys[indexFiltersArrayColor]]) {
            for (const filter of legende) {
              if (element === filter.slug) {
                colorsArray.push(filter.color);
                innerIcon = filter.icon;
              }
            }
          }
        }
      } else if (filtersKeys.length > 0) {
        for (const element of entity[filtersKeys[indexFiltersArrayColor]]) {
          for (const filter of filters[filtersKeys[indexFiltersArrayColor]].values) {
            if (element === filter.slug) {
              colorsArray.push(filter.color);
              innerIcon = filter.icon;
            }
          }
        }
      }

      //--- Allow to put active state on selected Institution marker
      if (selectedInstitution && entity.id === selectedInstitution.id) {
        isSelected = true;
      }
      return (
        <CustomMarker
          entity={entity}
          MarkerIcon={MarkerIcon(
            entity[filtersKeys[0]],
            colorsArray,
            isSelected,
            null,
            false,
            selectedInstitution,
            innerIcon,
            entity
          )}
          setSelectedInstitution={setSelectedInstitution}
          scrollbarInstance={scrollbarInstance}
          lineRefs={lineRefs}
          i={i}
          colorsArray={colorsArray}
          key={"customMarker" + entity.id}
          innerIcon={innerIcon}
          ref={customMarkerRefs.current[i]}
          popupRefs={popupRefs}
          filtersKeys={filtersKeys}
          sizeState={sizeState}
        />
      );
      return false
    } else {
      return false;
    }
  });
  //--- Creation and memoîzation component Cluster
  let markerGroup = useMemo(() => {
    return (
      <MarkerClusterGroup
        chunkedLoading
        iconCreateFunction={(cluster) =>
          MarkerIcon(
            null,
            null,
            false,
            cluster,
            true,
            selectedInstitution,
            null,
            null
          )
        }
        //--- Change this number to change cluster radius, when 0 -> disable clustering
        maxClusterRadius={
          process.env.REACT_APP_CLUSTER
            ? Number(process.env.REACT_APP_CLUSTER)
            : 0
        }
        showCoverageOnHover={false}
        spiderfyOnMaxZoom={true}
        ref={clusterRef}
      >
        {markers}
      </MarkerClusterGroup>
    );
  }, [markers]);

  // const tileLayerUrl =
  //   process.env.REACT_APP_TILELAYER?.length > 0
  //     ? process.env.REACT_APP_TILELAYER
  //     : "https://tile.openstreetmap.org/{z}/{x}/{y}.png";

  const positionZoomControl = !process.env.REACT_APP_ZOOMCONTROL ? "bottomright" : process.env.REACT_APP_ZOOMCONTROL

  const dataMapLegende = legende ? legende : filters
  const keyMapLegende = legende ? null : filtersKeys

  return (
    <MapContainer
      className="col-auto map__leaflet"
      zoomControl={false}
      scrollWheelZoom={false}    >
      <ChangeView
        markers={markers}
        selectedInstitution={selectedInstitution}
        data={data}
        customMarkerRefs={customMarkerRefs}
        mapRef={mapRef}
        setMapRef={setMapRef}
        clusterRef={clusterRef}
        MarkerIcon={MarkerIcon}
        popupRefs={popupRefs}
        sizeState={sizeState}
        userCurrentPosition={userCurrentPosition}
        selectedGeoAdress={selectedGeoAdress}
        setFilteredEntities={setFilteredEntities}
      />
      <TileLayerCustom />
      <ZoomControl position={positionZoomControl} />
      {markerGroup}
      {process.env.REACT_APP_GEODATA === "true" && !!GeoData && <GeoData />}

      {MapLegend && <MapLegend filters={dataMapLegende} filtersKeys={keyMapLegende} />}
    </MapContainer>
  );
};

export default Map;
